<div class="form-group">

    <ngx-colors [(ngModel)]="selectedColor" (change)="onChange()" ngx-colors-trigger></ngx-colors>
</div>
